// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","130":"d98b4e85","202":"09144bfe","406":"668f46cc","530":"25eb1daf","762":"212d9b70","908":"2ef195ae"}[chunkId] + ".chunk.js";
};